import React from 'react'; // eslint-disable-line
import ErrorItem from './ErrorItem';

const ErrorList = (props) => {
    return (
        <div>
            {props.errors && props.errors.length > 0
              && (
                  <div data-qa="error-list" className="error-list">
                      {props.errors?.map((error, i) => {
                          /* eslint-disable */
                  return (
                      <span key={i + 1}>
                                <ErrorItem
                                    id={i + 1}
                                    projectId={props.projectId}
                                    error={error}
                                    pagesFlag={props.pagesFlag}
                                />
                            </span>
                  );
                  /* eslint-enable */
                      })}

                  </div>
              )}
        </div>
    );
};

export default ErrorList;
